module.exports = new __parcel__URL__("certification-banner-image.4c20636d.svg").toString();